import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import * as s from "./styles/globalStyles";
import styled from "styled-components";

const truncate = (input, len) =>
  input.length > len ? `${input.substring(0, len)}...` : input;

export const StyledButton = styled.button`
  padding: 10px;
  border-radius: 50px;
  border: none;
  background-color: var(--secondary);
  padding: 10px;
  font-weight: bold;
  color: var(--secondary-text);
  width: 100px;
  cursor: pointer;
  box-shadow: var(--button-shadow);
  -webkit-box-shadow: var(--button-shadow);
  -moz-box-shadow: var(--button-shadow);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const StyledRoundButton = styled.button`
  padding: 10px;
  border-radius: 100%;
  border: none;
  background-color: var(--primary);
  padding: 10px;
  font-weight: bold;
  font-size: 15px;
  color: var(--primary-text);
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--button-shadow);
  -webkit-box-shadow: var(--button-shadow);
  -moz-box-shadow: var(--button-shadow);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const ResponsiveWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: stretched;
  align-items: stretched;
  width: 300px;
  @media (min-width: 767px) {
    flex-direction: row;
    width: 360px;
  }
`;

export const StyledLogo = styled.img`
  width: 200px;
  @media (min-width: 767px) {
    width: 300px;
  }
  transition: width 0.5s;
  transition: height 0.5s;
`;

export const StyledImg = styled.img`
  box-shadow: 0px 5px 11px 2px rgba(0, 0, 0, 0.7);
  border: 4px dashed var(--secondary);
  background-color: var(--accent);
  border-radius: 100%;
  width: 200px;
  @media (min-width: 900px) {
    width: 250px;
  }
  @media (min-width: 1000px) {
    width: 300px;
  }
  transition: width 0.5s;
`;

export const StyledLink = styled.a`
  color: var(--secondary);
  text-decoration: none;
`;

function App() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [claimingNft, setClaimingNft] = useState(false);
  const [feedback, setFeedback] = useState(`Click BUY to mint your NFTs.`);
  const [mintAmount, setMintAmount] = useState(1);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    NFT_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
  });

  const claimNFTs = () => {
    let cost = CONFIG.WEI_COST;
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalCostWei = String(cost * mintAmount);
    let totalGasLimit = String(gasLimit * mintAmount);
    console.log("Cost: ", totalCostWei);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`Minting your ${CONFIG.NFT_NAME}s...`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      /* .mint(mintAmount) */
      .mint(blockchain.account, mintAmount)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: totalCostWei,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Something went wrong. Try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          `Nice! Your ${CONFIG.NFT_NAME}s are minted! Visit your OpenSea profile to view them.`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };

  const decrementMintAmount = () => {
    let newMintAmount = mintAmount - 1;
    if (newMintAmount < 1) {
      newMintAmount = 1;
    }
    setMintAmount(newMintAmount);
  };

  const incrementMintAmount = () => {
    let newMintAmount = mintAmount + 1;
    if (newMintAmount > 50) {
      newMintAmount = 50;
    }
    setMintAmount(newMintAmount);
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  const getConfig = async () => {
    const configResponse = await fetch("./config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };

  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);


  return (
    <s.Screen>
      <s.Container
        flex={1}
        ai={"center"}
        /* style={{ padding: 24, backgroundColor: "var(--primary)" }} */
        /* image={CONFIG.SHOW_BACKGROUND ? "./config/images/bg.jpg" : null} */
      >
        
        <ResponsiveWrapper 
        flex={1} 
        className={"minting-card-wrapper"} 
        style={{ margin: 50 }} test>

          {/* 
          <s.Container flex={1} jc={"center"} ai={"center"}>
            <StyledImg 
              alt={"example"} 
              src={"./config/images/example.gif"
            } />
          </s.Container> 
          
          <s.SpacerLarge />
          */}

          <s.Container
            flex={2}
            jc={"center"}
            ai={"center"}
            className={"minting-card-inner"}
            style={{
              background: "var(--container-bg)",
              padding: 0,
              borderRadius: 16,
              /* border: "4px dashed var(--secondary)", */
              boxShadow: "0px 5px 11px 2px rgba(0,0,0,0.7)",
            }}
          >
            
            <s.Container
              jc={"center"}
              ai={"center"}
              className={"minting-card-header"}
              style={{
                width: "100%", 
                background: "var(--logo-bg)",
                padding: 0,
                borderRadius: "15px 15px 0 0",
                /* border: "4px dashed var(--secondary)", */
                /* boxShadow: "0px 5px 11px 2px rgba(0,0,0,0.7)", */
              }}
            >
              <StyledLogo 
                alt={"logo"} 
                src={"./config/images/logo.png"} 
                style={{ 
                  height: "250px", 
                  width: "auto"
                }}
              />
            </s.Container> 

            {/* <s.SpacerSmall /> */}

            <s.Container jc={"center"} ai={"center"} 
              className={"minting-card-body"}
              style={{ 
                background: "var(--texts-bg)",
                width: "100%" 
              }}
            >
              
              <s.SpacerSmall />

              {blockchain.account === "" || blockchain.smartContract === null ? (
                  null
                ) : (
                  <>

                  <s.TextTitle
                    className={"minting-card-supply-text"} 
                    style={{
                      textAlign: "center",
                      fontSize: 26,
                      fontWeight: "bold",
                      color: "var(--supply-text)",
                      lineHeight: 1
                    }}
                  >
                    {data.totalSupply} / {CONFIG.MAX_SUPPLY}
                  </s.TextTitle>
                  
                  <s.SpacerSmall />

                  </>
              )}

              {Number(data.totalSupply) >= CONFIG.MAX_SUPPLY ? (
                <>
                  <s.TextTitle
                    className={"minting-card-soldout-text"} 
                    style={{ textAlign: "center", color: "var(--feedback-text)" }}
                  >
                    The sale has ended.
                  </s.TextTitle>
                  <s.TextDescription
                    className={"minting-card-soldout-text"} 
                    style={{ textAlign: "center", color: "var(--feedback-text)" }}
                  >
                    You can still find {CONFIG.NFT_NAME}s on
                  </s.TextDescription>
                  {/* <s.SpacerSmall /> */}
                  <StyledLink 
                    className={"minting-card-soldout-link"} 
                    target={"_blank"} 
                    href={CONFIG.MARKETPLACE_LINK}>
                    {CONFIG.MARKETPLACE}
                  </StyledLink>
                </>
              ) : (
                <>
                  <s.TextTitle
                    className={"minting-card-cost-text-first"} 
                    style={{ textAlign: "center", color: "var(--cost-text)", fontSize: 18, lineHeight: 1 }}
                  >
                    1 mint costs
                  </s.TextTitle>
                  <s.TextTitle
                    className={"minting-card-cost-text-second"} 
                    style={{ textAlign: "center", color: "var(--cost-text)", fontSize: 26, lineHeight: 1 }}
                  >
                    {CONFIG.DISPLAY_COST}{" "}{CONFIG.NETWORK.SYMBOL}
                  </s.TextTitle>
                  <s.TextDescription
                    className={"minting-card-cost-text-third"} 
                    style={{ textAlign: "center", color: "var(--cost-text)", fontSize: 14, lineHeight: 1.1 }}
                  >
                    + gas fees
                  </s.TextDescription>

                  <s.SpacerSmall />

                  {blockchain.account === "" ||
                  blockchain.smartContract === null ? (

                    <s.Container ai={"center"} jc={"center"}>
                      <s.TextDescription
                        className={"minting-card-connect-message-text"} 
                        style={{
                          textAlign: "center",
                          fontWeight: "bold",
                          color: "var(--feedback-text)",
                        }}
                      >
                        Connect to the {CONFIG.NETWORK.NAME} network
                      </s.TextDescription>

                      <s.SpacerSmall />

                      <StyledButton
                        className={"minting-card-connect-button"} 
                        style={{ 
                          background: "var(--connect-button)",
                          color: "var(--connect-button-text)",
                          padding: "12px 15px 10px",
                          width: 120,
                          fontSize: 16,
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          dispatch(connect());
                          getData();
                        }}
                      >
                        CONNECT
                      </StyledButton>

                      {blockchain.errorMsg !== "" ? (
                        <>
                          <s.SpacerSmall />
                          <s.TextDescription
                            style={{
                              textAlign: "center",
                              fontWeight: "bold",
                              color: "var(--error-text)",
                            }}
                          >
                            {blockchain.errorMsg}
                          </s.TextDescription>
                        </>
                      ) : null}

                    </s.Container>
                  ) : (
                    <>
                      <s.TextDescription
                        className={"minting-card-feedback-text"} 
                        style={{
                          textAlign: "center",
                          fontWeight: "bold",
                          color: "var(--feedback-text)",
                        }}
                      >
                        {feedback}
                      </s.TextDescription>

                      <s.SpacerXSmall />

                      <s.Container ai={"center"} jc={"center"} fd={"row"}>
                        <StyledRoundButton
                          className={"minting-card-number-button"} 
                          style={{ 
                            background: "var(--number-button)",
                            color: "var(--number-button-text)",
                            shadowColor: "var(--button-shadow)",
                            fontSize: 20,
                            lineHeight: 0.4 
                          }}
                          disabled={claimingNft ? 1 : 0}
                          onClick={(e) => {
                            e.preventDefault();
                            decrementMintAmount();
                          }}
                        >
                          -
                        </StyledRoundButton>
                        
                        <s.SpacerMedium />

                        <s.TextDescription
                          className={"minting-card-number-text"} 
                          style={{
                            textAlign: "center",
                            fontSize: 20,
                            color: "var(--number-text)",
                            minWidth: 24,
                          }}
                        >
                          {mintAmount}
                        </s.TextDescription>

                        <s.SpacerMedium />

                        <StyledRoundButton
                          className={"minting-card-number-button"} 
                          style={{ 
                            background: "var(--number-button)",
                            color: "var(--number-button-text)",
                            shadowColor: "var(--button-shadow)",
                            fontSize: 20,
                            lineHeight: 0.4 
                          }}
                          disabled={claimingNft ? 1 : 0}
                          onClick={(e) => {
                            e.preventDefault();
                            incrementMintAmount();
                          }}
                        >
                          +
                        </StyledRoundButton>
                      </s.Container>

                      <s.SpacerSmall />
                      
                      <s.Container ai={"center"} jc={"center"} fd={"row"}>
                        <StyledButton
                          className={"minting-card-buy-button"}
                          style={{ 
                            background: "var(--buy-button)",
                            color: "var(--buy-button-text)",
                            padding: "12px 15px 10px",
                            width: 130,
                            fontSize: 16,
                          }}
                          disabled={claimingNft ? 1 : 0}
                          onClick={(e) => {
                            e.preventDefault();
                            claimNFTs();
                            getData();
                          }}
                        >
                          {claimingNft ? "WAITING" : "BUY"}
                        </StyledButton>
                      </s.Container>
                    </>
                  )}
                </>
              )}
              
              <s.SpacerSmall />

            </s.Container> 
            
           {/*  <s.SpacerSmall /> */}

            <s.Container jc={"center"} ai={"center"} 
              className={"minting-card-footer"}
              style={{ 
                width: "100%", 
                background: "var(--bottom-bg)",
                padding: 2,
                borderRadius: "0 0 15px 15px",
              }}
            >

            <s.TextDescription
              style={{
                textAlign: "left",
                width: "100%",
                fontSize: 14,
              }}
            >
              <StyledLink 
                className={"minting-card-footer-link"}
                target={"_blank"} 
                href={CONFIG.SCAN_LINK} 
                style={{
                  margin: "0 6px",
                  color: "var(--footer-link)",
                }}
              >
                {/* {truncate(CONFIG.CONTRACT_ADDRESS, 15)} */}
                View Contract
              </StyledLink>
            </s.TextDescription>

            {/* <s.SpacerMedium /> */}
            </s.Container> 

          </s.Container>

          {/*
          <s.SpacerLarge />

          <s.Container flex={1} jc={"center"} ai={"center"}>
            <StyledImg
              alt={"example"}
              src={"./config/images/example.gif"}
              style={{ transform: "scaleX(-1)" }}
            />
          </s.Container> */}

        </ResponsiveWrapper>

        {/* <s.SpacerMedium />

        <s.Container jc={"center"} ai={"center"} style={{ width: "70%" }}>

          <s.TextDescription
            style={{
              textAlign: "center",
              color: "var(--primary-text)",
            }}
          >
            Please make sure you are connected to the right network (
            {CONFIG.NETWORK.NAME} Mainnet) and the correct address. Please note:
            Once you make the purchase, you cannot undo this action.
          </s.TextDescription>

          <s.SpacerSmall />

          <s.TextDescription
            style={{
              textAlign: "center",
              color: "var(--primary-text)",
            }}
          >
            We have set the gas limit to {CONFIG.GAS_LIMIT} for the contract to
            successfully mint your NFT. We recommend that you don't lower the
            gas limit.
          </s.TextDescription>

        </s.Container> */}
        
      </s.Container>
    </s.Screen>
  );
}

export default App;
